import React, { useMemo } from "react";
import BarChart from "components/charts/BarChart";

// Props:
// - years: number[]
// - tcpTotalsByYear: Record<year, Record<tcpName, amount>>
const CATcpChart = ({ years, tcpTotalsByYear }) => {
  const { chartSeries, chartOptions } = useMemo(() => {
    // Collect the union of all TCP names across years
    const tcpSet = new Set();
    years.forEach((year) => {
      const totals = tcpTotalsByYear[year] || {};
      Object.keys(totals).forEach((tcp) => tcpSet.add(tcp));
    });
    const tcpNames = Array.from(tcpSet);

    // Series per year, stacked horizontally across TCPs
    const series = years.map((year) => ({
      name: String(year),
      data: tcpNames.map((tcp) => Number((tcpTotalsByYear[year] || {})[tcp] || 0)),
    }));

    const options = {
      chart: { type: "bar", stacked: true, toolbar: { show: false } },
      plotOptions: { bar: { horizontal: true, barHeight: "70%", borderRadius: 4 } },
      xaxis: {
        categories: tcpNames,
        labels: { formatter: (v) => new Intl.NumberFormat("en-EN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v) },
        title: { text: "Montant HT (DH)" },
      },
      yaxis: { labels: { style: { fontSize: "12px" } } },
      dataLabels: {
        enabled: true,
        formatter: (val) => new Intl.NumberFormat("en-EN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(val) + " DH",
        style: { fontSize: "12px", fontWeight: "bold", colors: ["#374151"] },
        background: { enabled: true, borderRadius: 6, borderWidth: 0, opacity: 0.85, dropShadow: { enabled: false } },
      },
      tooltip: {
        theme: 'dark',
        y: { formatter: (val) => new Intl.NumberFormat("en-EN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(val) + " DH" },
      },
      legend: { position: "top", horizontalAlign: "right" },
      colors: ["#6b7280", "#f59e0b", "#10b981", "#3b82f6", "#ef4444", "#8b5cf6", "#14b8a6"],
      grid: { strokeDashArray: 4 },
    };

    return { chartSeries: series, chartOptions: options };
  }, [years, tcpTotalsByYear]);

  return (
    <BarChart chartData={chartSeries} chartOptions={chartOptions} width="100%" height={600} />
  );
};

export default CATcpChart;
